import {React, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'

import userStore from "../../store/slice/auth.slice"
import toast from 'react-hot-toast'

function ForgetPassword(){
    
    const forgetPassword = userStore((state) => state.forgetPassword)

    const response = userStore((state) => state.s_forgetPassword)
    
    const { register, handleSubmit, formState: { errors } } = useForm()

    const navigate = useNavigate()
    
    useEffect(()=>{
        if(response.response !== null){
            if(response.response.response_code === '01'){
                toast.success(response.response.message)
            }else{
                toast.error(response.message)
            }
        }
    }, [response])

    const onSubmit = (data) => {     
        forgetPassword(data.email)
    }
    
    return (
        <div className="login-signup-form-container">
            <form className="login-form" onSubmit={handleSubmit(onSubmit)} autoComplete='false'>
                <div className="form-heading">
                    <p>Please Enter Registered Email Address</p>
                </div>

                <div className="form-inputs">
                    <input type="email" name="email" placeholder="Enter Registered Email Address" autoComplete='false'
                        {...register("email", {required: true})} />
                    <div className="message">{errors.email && <span>This field is required</span>}</div>
                </div>

                <div className="button login-signup-btn">
                    <button type="submit" className="lsbtn" onClick={(e)=>{return false}}> Submit </button>
                    <button button onClick={() => navigate(-1)} type="button" className="signup"> Back </button>
                </div>
            </form>
        </div>
    )
}

export default ForgetPassword